
/**
 * Retrieves the key of a given value in an enum.
 *
 * @template T - The enum type.
 * @param {T} myEnum - The enum object.
 * @param {string} enumValue - The value to search for in the enum.
 * @returns {(keyof T | null)} - The key of the enum value if found, otherwise null.
 */
export function getEnumKeyByEnumValue<T extends {[index: string]: string}>(myEnum: T, enumValue: string): keyof T | null {
    let keys = Object.keys(myEnum).filter(x => myEnum[x] == enumValue);
    return keys.length > 0 ? keys[0] : null;
}

